import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/lib/auth";

export default function RequireFreelancer({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center text-slate-500" data-testid="freelancer-loading">
        Loading…
      </div>
    );
  }
  if (!user) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }
  if (user.role !== "freelancer") {
    // Wrong role — send to their appropriate landing
    const to = user.role === "admin" ? "/admin" : "/";
    return <Navigate to={to} replace />;
  }
  return children;
}
